import { EventTicketPurchaseWithEvent, EventTicketTiming } from '../models/Event';

function coerceDate(value: Date | string | undefined): Date | undefined {
  if (!value) {
    return undefined;
  }

  const date: Date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date;
}

export function getEventTicketTiming(
  ticket: EventTicketPurchaseWithEvent,
  now: Date = new Date()
): EventTicketTiming {
  if (ticket.ticketTiming) {
    return ticket.ticketTiming;
  }

  const startDate: Date | undefined = coerceDate(ticket.eventStartDate ?? ticket.eventDate);
  const endDate: Date | undefined = coerceDate(ticket.eventEndDate);

  if (startDate && startDate > now) {
    return 'UPCOMING';
  }

  if (endDate && endDate < now) {
    return 'PAST';
  }

  if (startDate && startDate <= now) {
    return 'CURRENT';
  }

  return ticket.isUpcoming ? 'UPCOMING' : 'PAST';
}

export function isCurrentOrUpcomingEventTicket(ticket: EventTicketPurchaseWithEvent): boolean {
  const timing: EventTicketTiming = getEventTicketTiming(ticket);
  return timing === 'UPCOMING' || timing === 'CURRENT';
}

export function hasAnyEventTickets(tickets: EventTicketPurchaseWithEvent[]): boolean {
  return tickets.length > 0;
}

export function countCurrentOrUpcomingEventTickets(tickets: EventTicketPurchaseWithEvent[]): number {
  return tickets.filter((ticket: EventTicketPurchaseWithEvent) => isCurrentOrUpcomingEventTicket(ticket)).length;
}

export function getTicketDisplayDate(ticket: EventTicketPurchaseWithEvent): Date | string | undefined {
  return ticket.eventStartDate ?? ticket.eventDate;
}

export function getTicketDisplayLocation(ticket: EventTicketPurchaseWithEvent): string | undefined {
  return ticket.eventVenueName ?? ticket.eventLocation;
}

export function getTicketsForEvent(
  tickets: EventTicketPurchaseWithEvent[],
  eventId: number
): EventTicketPurchaseWithEvent[] {
  return tickets.filter((ticket: EventTicketPurchaseWithEvent) => ticket.eventId === eventId);
}
